import React from 'react'

const BlindContent: React.FC = () => {
  return <h2 className="blind">본문 영역</h2>
}

export default BlindContent
